module.exports = __webpack_public_path__ + "img/h2.1e0340ce.png";